import { getTemporaryLayout } from './utils';
import { useContext } from 'react';
import { MediaQueryContext } from 'libs/contexts';

type MainLayoutProps = {
  layoutProps: Object;
  children: React.ReactNode;
  getLayout: Function;
};

/**
 * @description: 兼容已开发的不规范组件和后续开发的规范组件
 * @param {object} getLayout 页面组件代码中定义的getLayout，用于获取自定义布局组件
 * @param {object} layoutProps 如果页面组件有这个属性就使用getTemporaryLayout获取布局组件
 * @returns
 */
export default function MainLayout({ getLayout, layoutProps, children }: MainLayoutProps) {
  const { isMobile } = useContext(MediaQueryContext);
  let resultPage: JSX.Element;
  if (layoutProps) {
    resultPage = getTemporaryLayout(children, layoutProps, isMobile);
  } else {
    resultPage = getLayout(children);
  }

  return resultPage;
}
